import { PaymentSuccessResponse } from 'flutterwave-angular-v3';
import { EnrolService } from './../../../_services/enrol.service';


import { FormControl, FormGroup, Validators } from '@angular/forms';
import { StudentService } from 'src/app/_services/student.service';

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EnrolmentRequestInformation } from 'src/app/_models/EnrolmentRequestInformation';
import { StudentRegData } from 'src/app/_models/registration/StudentRegData';
import { ResultData } from 'src/app/_models/ResultData';
import { CountryService } from 'src/app/_services/country.service';

declare var $ : any;
@Component({
  selector: 'app-subscription-grouping-student-new',
  templateUrl: './subscription-grouping-student-new.component.html',
  styleUrls: ['./subscription-grouping-student-new.component.css']
})
export class SubscriptionGroupingStudentNewComponent implements OnInit {
  countries=[]
  errorSaving=false
  registering=false

  @Output() enrolLoading = new EventEmitter<boolean>()
  @Output() finishedGroupTrialRegStudentEmitter= new EventEmitter<string>()
  @Output()  notificationRegFinished = new EventEmitter<string>()
  @Input() subscriptionGrouping:any=undefined
  levels = []
  subscriptionChoices = []
  subjects = []
  showButtons = false
  paymentOrderId:string
  invoiceId:string
  studentDetail:any=undefined
  jsonGrouping:any=undefined
  paymentData={amount:0}


  myForm = new FormGroup({
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required])
  });
  constructor(
    private studentService:StudentService,
     private enrolService:EnrolService
    ,private countryService:CountryService) { }
    get f(){
      return this.myForm.controls
    }

  ngOnInit(): void {
    this.paymentOrderId=this.studentService.generatePaymentOrderId()
    this.errorSaving=false
    this.countryService.getCountriesIdAndName().subscribe(
      x=>{this.countries= x }
    )

  }
  onSubmit(){
    this.registering=true
    let dd=this.formatDataRegStudent(this.myForm.value)
    this.studentService.registerGroupStudent(dd,this.subscriptionGrouping.server_subscription_grouping_id).subscribe(
      val=>{
        if(val['server_student_id']==0){
          this.errorSaving=true
        }
        else{
          this.studentDetail=val['studentDetail']
          this.jsonGrouping=val['grouping']
          this.enrolTrialStudent()
        }
      }
    )

  }
  enrolTrialStudent() {
    this.enrolLoading.emit(true)

    let requests: Array<StudentRegData> = []
    let mySubjects = [this.jsonGrouping.subjectId]
    for (let i = 0; i < mySubjects.length; i++) {
      let dd = this.formatDataSaveInvoice(mySubjects[i])
      requests.push(dd)
    }

  let eInfo = new EnrolmentRequestInformation()
    eInfo.settlement_choice.subscription_choice="month";

    eInfo.requests = requests
    eInfo.server_guardian_id = this.studentDetail.server_guardian_id
    this.studentService.enrolSaveInvoice(eInfo).subscribe(
      {
        next:(data:ResultData)=>{
          let invoiceData = data.rs.data
        this.invoiceId=invoiceData.id
        if(invoiceData.id!=0){
          this.enrolLoading.emit(false)

          let verifyData={status:"successful",id:invoiceData.id,amount:0,tx_ref:this.paymentOrderId}
          let pData = this.enrolService.formatProvisionData(this.invoiceId,verifyData,this.paymentData,1,this.studentDetail.server_guardian_id)
          this.studentService.enrolProvision(pData).subscribe(
            x=>{
              this.closeModal()
            }
          )
        }
        this.closeModal()

        },error:(err)=>{}
      }
    )
  }


  formatDataRegStudent(formData){
    let data = new URLSearchParams();
    data.set('firstName', formData.firstName);
    data.set('lastName', formData.lastName);
    data.set('paymentOrderId', this.paymentOrderId);
    data.set('server_subscription_grouping_id', this.subscriptionGrouping.server_subscription_grouping_id.toString())
    return data.toString()
  }

  closeModal(){
    this.registering=false
    this.finishedGroupTrialRegStudentEmitter.emit("trialEnrolModal")
  }

  formatProvisionData(response: PaymentSuccessResponse){
    let data = new URLSearchParams();
    data.set('paymentOrderId', response.tx_ref);
    data.set('id', this.invoiceId);
    data.set('status', response.status);
    data.set('amount', response.amount.toString());
    return data.toString()
  }
  formatDataSaveInvoice(server_subject_id:number) {
    let data = new StudentRegData();



    data.paymentOrderId= this.paymentOrderId
    data.server_student_id = this.studentDetail.server_student_id
    data.server_user_id= this.studentDetail.server_user_id

    data.server_subject_id=server_subject_id
    data.server_level_id= this.jsonGrouping.levelId;
    data.server_country_id= this.jsonGrouping.countryId;
    data.coupon=0


    return data
  }
}
